import React from 'react'
import {Carousel} from 'antd'
import {Link} from 'react-router-dom'

import BButton from 'components/Form/Fields/BButton'

const LandingCarousel = ({data}) => <div>
  <div className='land-carParent'>
    <Carousel autoplay>
      {data.map((e, i) => (
        <div key={'carousel' + i}>
          <div className='land-carItem'>
            <div>
              <h1>{e.title[0]}&nbsp;</h1>
              <h1>{e.title[1]}&nbsp;</h1>
              <h1><b>{e.title[2]}</b>&nbsp;</h1>
              <Link to={e.link}><BButton yellow>SHOP NOW ON BUILDIRO</BButton></Link>
            </div>
            <div style={{backgroundImage: `url(${e.image})`}}/>
          </div>
        </div>
      ))}
    </Carousel>
  </div>

  <div className='land-carFourBenefits'>
    <div>
      <div>
        <h1>Buildiro Direct</h1>
        <p>90 minute delivery in London for over 30,000 products</p>
      </div>
    </div>
    <div>
      <div>
        <h1>Making tax digital</h1>
        <p>Invoices are automatically sent to your accountant</p>
      </div>
    </div>
    <div>
      <div>
        <h1>500k +</h1>
        <p>Over 500k products in one place from verified UK suppliers</p>
      </div>
    </div>
    <div>
      <div>
        <h1>Buildiro Rewards</h1>
        <p>Receive rewards on every purchase made on Buildiro</p>
      </div>
    </div>
  </div>
</div>

export default LandingCarousel
